<header id="app-header">
    <nav class="app-nav transparent">
        <div class="nav-wrapper">
            <div>
                <a title="Start">
                    <img src="assets/images/logo-krematorium-am-limes.png" class="rtk-icon">
                </a>
                <a id="slideMenuButton" class="button-collapse link-cursor" data-activates="mobile-drawer" title="Start"
                    style="color: #000">
                    <i class="material-icons">menu</i>
                </a>
                <div class="side-nav" id="mobile-drawer">
                    <ul>
                        <i class="material-icons sidenav-close" onclick="closeMobileDrawer()"
                            style="color: black; margin-left: auto; margin-right: 15px;">close</i>
                        <li>
                            <a class="black-text" routerLinkActive="active" routerLink="burials">Aufträge</a>
                        </li>
                        <li *ngIf="this.currentLocationName != 'Krema-Mechernich' && !this.hideDocsAndCemetery">
                            <a class="black-text" routerLinkActive="active" routerLink="cremation">Einäscherung</a>
                        </li>
                        <li *ngIf="!this.hideDocsAndCemetery && !this.hidePartnerfriedhoefeNav">
                            <a class="black-text" routerLinkActive="active" routerLink="partnered">Partnerfriedhöfe</a>
                        </li>
                        <li *ngIf="!this.hideDocsAndCemetery && !this.hideTips">
                            <a class="black-text" routerLinkActive="active" routerLink="tips">Tipps</a>
                        </li>
                        <li>
                            <a class="black-text" (click)="printAllInvoicesButtonClicked()">Abrechnung</a>
                        </li>
                        <li>
                            <a class="black-text" onclick="openModalWithID('logoutModal')">Logout</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="hide-on-med-and-down nav-menu center menu-div">
                <a class="nav-link black-text" routerLinkActive="active" routerLink="burials" title="Aufträge">
                    <h2 class="redesign">Aufträge</h2>
                </a>
                <a class="nav-link black-text" routerLinkActive="active" routerLink="cremation" title="Einäscherung" *ngIf="this.currentLocationName != 'Krema-Mechernich' && !this.hideDocsAndCemetery">
                    <h2 class="redesign">Einäscherung</h2>
                </a>
                <a class="nav-link black-text" routerLinkActive="active" routerLink="partnered" title="Friedhöfe" *ngIf="this.currentLocationName != 'Krema-Mechernich' && !this.hideDocsAndCemetery && !this.hidePartnerfriedhoefeNav">
                    <h2 class="redesign">Partnerfriedhöfe</h2>
                </a>
                <a class="nav-link black-text" routerLinkActive="active" routerLink="tips" title="Tipps" *ngIf="this.currentLocationName != 'Krema-Mechernich' && !this.hideDocsAndCemetery && !this.hideTips">
                    <h2 class="redesign">Tipps</h2>
                </a>
                <a class="nav-link black-text" title="Abrechnung" (click)="printAllInvoicesButtonClicked()">
                    <h2 class="redesign">Abrechnung</h2>
                </a>
                <a class="nav-link black-text" title="Ausloggen" onclick="openModalWithID('logoutModal')">
                    <h2 class="redesign">Ausloggen</h2>
                </a>
            </div>
            <div><!-- Spacer --></div>
        </div>
    </nav>
</header>

<main id="main" class="container dash">
    <div class="row main-content-row">
        <div class="col s12">
            <router-outlet></router-outlet>
        </div>
    </div>
</main>

<div id="searchModal" class="modal">
    <div class="modal-content column">
        <div class="row" style="justify-content: flex-end; width: 100%; margin-bottom: 0">
            <a class="btn-flat" onclick="closeModalWithID('searchModal')"
                style="margin: 0 !important; padding: 0 !important;">
                <i class="material-icons large">close</i>
            </a>
        </div>

        <div *ngIf="isSearchLoading" class="juvo-spinner row" style="justify-content: center;">
            <div class="preloader-wrapper big active">
                <div class="spinner-layer spinner-green-only">
                    <div class="circle-clipper left">
                        <div class="circle"></div>
                    </div>
                    <div class="gap-patch">
                        <div class="circle"></div>
                    </div>
                    <div class="circle-clipper right">
                        <div class="circle"></div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="!isSearchLoading" class="input-field search-input col s12" style="margin: 0">
            <input id="globalSearch" type="search" [(ngModel)]="search" (keyup.enter)="requestSearch()">
            <label for="globalSearch" class="active">Suche</label>
        </div>

        <div *ngIf="success" class="search-results col">
            <span class="search-success-message subtext">{{msg}}</span>
            <div *ngFor="let res in result" class="search-result-entry">
                <a href="{{res.fileUrl}}" target="_blank">{{ res.fileName }}</a>
            </div>
        </div>
    </div>
</div>

<div id="logoutModal" class="modal">
    <div class="modal-content column">

        <h2 class="redesign subtext t-gap">Sind Sie sicher, dass Sie sich ausloggen wollen?</h2>

        <div class="row space-between" style="width: 50%;">
            <h3 class="action redesign prefixed cursor-pointer" onclick="closeModalWithID('logoutModal')">Abbrechen</h3>
            <h3 class="action redesign prefixed cursor-pointer" onclick="logoutUser()">Ok</h3>
        </div>

    </div>
</div>